import "core-js/modules/es.array.push.js";
import Cookie from 'js-cookie';
import { mapState } from 'vuex';
import AgoraClient from '@/assets/js/rtc-client-ng';
import { audioContextObj } from '@/assets/js/audioContext';
import { createCameraVideoTrack, createMicrophoneAudioTrack, getMediaDevice, playVideoTrack, changeDeviceAndSaveId } from '@/assets/js/agoraFeature.js';
import { getTheme, setTheme } from '@/assets/js/theme.js';
import { addTabTitle, handleLocalStorage, removeDuplicateSegments } from '@/assets/js/utils.js';
import { judgeCanControl } from '@/assets/js/attendUser.js';
import { showDeviceTips } from '@/assets/js/common.js';
const nodeUrl = require('url');
export default {
  data() {
    return {
      id: '',
      startOrStop: false,
      deviceId: '',
      applicationName: handleLocalStorage('get', 'applicationName'),
      fontVersion: '',
      backendVersion: '',
      splitEmail: '',
      testMicVisible: false,
      rtc: null,
      devicesInfo: {},
      camera: true,
      mic: true,
      speaker: true,
      partyName: '',
      oldPartyName: '',
      //  用来判断是否需要调用更新 title 的接口
      nickName: '',
      passCode: '',
      localVideoTrack: null,
      localAudioTrack: null,
      partyCode: '',
      checkInfo: {},
      commonPartyInfo: {},
      setInfo: {
        speaker: false,
        camera: false,
        mic: false,
        useCamera: false
      },
      organization: '',
      updateTitleUrl: {
        0: '/partyline-backend/commonParty/updateTitle',
        1: '/partyline-backend/group/updateTitle',
        2: '/partyline-backend/conference/updateTitle',
        13: '/partyline-backend/kiosk/updateTitle'
      },
      Parser: require('@/assets/js/us.js'),
      isWindows: true,
      isMac: false,
      openAnywhereTimer: null,
      ontouch: 'ontouchend' in document,
      logoSvg: '',
      cameraName: '',
      showInitMessage: false,
      modelType: '',
      notNeedVideoTextMap: {
        1: 'Gallery view',
        13: 'Kiosk',
        18: 'Station'
      }
    };
  },
  setup() {
    const {
      isDark
    } = getTheme();
    return {
      isDark,
      getTheme,
      setTheme,
      showDeviceTips
    };
  },
  computed: {
    ...mapState({
      State: state => state,
      userInfo: state => state.loginInfo
    }),
    showNotNeedVideoBox() {
      const channelMoel = this.checkInfo.channelModel;
      return this.checkInfo.owner && (channelMoel == 1 || channelMoel == 13) || this.checkInfo.channelModel == 18;
    },
    showNotNeedVideoText() {
      return this.$t('partyInfo.notNeedVideo', {
        partyModule: this.notNeedVideoTextMap[this.checkInfo.channelModel]
      });
    },
    returnPartyID() {
      if (!this.partyCode) return;
      return this.$t('partyInfo.partyID') + ':  ' + this.$options.filters.returnStrByInfo(this.partyCode, this.partyCode.length === 9 ? 3 : 4);
    },
    showPartyName() {
      const info = this.commonPartyInfo;
      if (info && info.partyName) return info.partyName;
      if (info && (info.startPartyTime || info.createTime)) {
        return new Date(info.startPartyTime || info.createTime).toLocaleDateString() + '   ' + new Date(info.startPartyTime || info.createTime).toLocaleTimeString();
      } else {
        return '';
      }
    },
    showNickNameInput() {
      let flag = false;
      if (this.checkInfo.owner) {
        if (this.State.channelModeByRouteName[this.checkInfo.channelModel] === 'party' || this.State.channelModeByRouteName[this.checkInfo.channelModel] === 'coordinator') {
          flag = true;
        }
      } else {
        flag = true;
      }
      return flag;
    },
    cameraOn() {
      let cameraOn = true;
      if (this.checkInfo.owner) {
        // 特殊处理 gallery view 和 kiosk
        if (this.checkInfo.channelModel == 1 || this.checkInfo.channelModel == 13 || this.checkInfo.channelModel == 18) {
          cameraOn = false;
          this.camera = false;
        } else {
          if (!this.camera || !this.devicesInfo.cameraList || !this.devicesInfo.cameraList.length) {
            cameraOn = false;
          }
        }
      } else {
        if (!this.camera || !this.devicesInfo.cameraList || !this.devicesInfo.cameraList.length) {
          cameraOn = false;
        }
        if (this.checkInfo.channelModel == 18) {
          cameraOn = false;
        }
      }
      return cameraOn;
    },
    cameraOff() {
      let cameraOff = false;
      const channelModel = this.checkInfo.channelModel;
      if (this.checkInfo.owner) {
        if (channelModel == 1 || channelModel == 13 || channelModel == 18) {
          cameraOff = true;
        } else {
          if (!this.camera || !this.devicesInfo.cameraList || !this.devicesInfo.cameraList.length) {
            cameraOff = true;
          }
        }
      } else {
        if (channelModel == 18) {
          cameraOff = true;
        }
        if (!this.camera || !this.devicesInfo.cameraList || !this.devicesInfo.cameraList.length) {
          cameraOff = true;
        }
      }
      return cameraOff;
    },
    cameraOffClass() {
      let _class = '';
      if (this.checkInfo.owner && (this.checkInfo.channelModel == 1 || this.checkInfo.channelModel == 13)) _class = 'disabled';
      return _class;
    }
  },
  watch: {
    deviceSelectId(val) {
      // this.handleDefault()
      this.deviceId = this.devicesInfo.microphoneId;
    },
    startOrStop(val) {
      if (!this.localAudioTrack) return;
      if (val == true) {
        this.localAudioTrack.play();
      } else if (val == false) {
        this.localAudioTrack.setEnabled(false);
        this.localAudioTrack.stop();
      }
    }
  },
  async created() {
    document.title = this.$t('common.partylinePreviewInit');
    const URL = nodeUrl.parse(location.href, true);
    this.modelType = URL.query.model;
    const idRaw = URL.query.id ? URL.query.id.replace(/[^0-9]/ig, '') : '';
    const join_idRaw = URL.query.join_id ? URL.query.join_id.replace(/[^0-9]/ig, '') : '';
    // 检查各种长度的重复情况
    const id = [18, 24, 32].includes(idRaw.length) ? removeDuplicateSegments(idRaw, idRaw.length) : idRaw;
    const join_id = [18, 24, 32].includes(join_idRaw.length) ? removeDuplicateSegments(join_idRaw, join_idRaw.length) : join_idRaw;
    this.partyCode = id || join_id || '';
    // this.getMediaDeviceStatus()
    this.rtc = new AgoraClient(this.agoraCallback);

    // 获取前端版本号
    let fontEndVersionStr = handleLocalStorage('get', 'partylineVersion');
    if (fontEndVersionStr && fontEndVersionStr.includes('_')) {
      fontEndVersionStr = fontEndVersionStr.substring(0, fontEndVersionStr.indexOf('_'));
    }
    this.fontVersion = fontEndVersionStr;
    // 获取后台版本号
    await this.$store.dispatch('getBackendVersion');
    let backEndVersionStr = handleLocalStorage('get', 'backendVersion');
    if (backEndVersionStr && backEndVersionStr.includes('_')) {
      backEndVersionStr = backEndVersionStr.substring(0, backEndVersionStr.indexOf('_'));
    }
    this.backendVersion = backEndVersionStr;
    const parserObj = this.Parser && new this.Parser();
    this.isMac = parserObj && parserObj.getOS().name === 'Mac OS';
    this.isWindows = parserObj && parserObj.getOS().name === 'Windows';
  },
  async mounted() {
    document.addEventListener('keyup', event => {
      if (event.keyCode === 13) {
        this.jumpPage();
      }
    });
    this.logoSvg = `#${this.State.commonLogo}`;
    await this.checkIsHost();
    if (!this.checkInfo.enable) return;
    this.devicesInfo = await getMediaDevice(this.rtc);
    if (!handleLocalStorage('get', 'speakerId')) {
      handleLocalStorage('set', 'speakerId', this.devicesInfo.speakerId);
    }
    this.deviceId = this.devicesInfo.microphoneId;
    if (!this.checkInfo.owner || this.checkInfo.owner && this.checkInfo.channelModel != 1 && this.checkInfo.channelModel != 13) {
      if (this.devicesInfo.cameraId) {
        try {
          this.devicesInfo && this.devicesInfo.cameraList.forEach(item => {
            if (item.deviceId == this.devicesInfo.cameraId) {
              this.cameraName = item.label;
            }
          });
          if (this.checkInfo.channelModel == 18) return;
          this.State.initCamera = true;
          if (this.rtc) {
            this.localVideoTrack = await this.rtc._AgoraRTC.createCameraVideoTrack({
              cameraId: this.devicesInfo.cameraId,
              // this.devicesInfo.cameraId
              encoderConfig: {
                // 视频分辨率
                width: 640,
                height: 360
              },
              AgoraRTC: this.rtc._AgoraRTC
            });
          }
        } catch (e) {
          this.State.showInitCameraTips = true;
        }
        this.State.initCamera = false;
        if (this.localVideoTrack) {
          this.State.showInitCameraTips = false;
          await playVideoTrack(this.localVideoTrack);
          this.devicesInfo.cameraId = this.localVideoTrack._config.cameraId;
        }
      }
    }
    if (this.devicesInfo.microphoneId && this.rtc && this.rtc._AgoraRTC && !this.devicesInfo.microphoneError) {
      // 初始化麦克风声音
      this.localAudioTrack = await this.rtc._AgoraRTC.createMicrophoneAudioTrack({
        AEC: true,
        // 回声消除
        ANS: true,
        // 噪声抑制
        microphoneId: this.devicesInfo.microphoneId // 指定麦克风
      });
    }

    if (this.localAudioTrack) {
      const media = new MediaStream();
      media.addTrack(this.localAudioTrack._mediaStreamTrack);
      audioContextObj.audioTrack(media, 'volume');
      setTimeout(() => {
        audioContextObj.resumeAudio('volume');
      }, 1000);
    }
  },
  beforeDestroy() {
    document.removeEventListener('keyup', this.handleEnterKey);
  },
  methods: {
    dealAnywhereInstall() {
      this.$router.push({
        name: 'joinParty',
        query: {
          join_id: this.partyCode
        }
      });
    },
    changeParticipantLanguage() {
      if (this.$i18n.locale === 'zh' || this.$i18n.locale === 'zh-CN') {
        Cookie.set('userLanguage', 'en', {
          domain: '.tvunetworks.com'
        });
        this.$i18n.locale = 'en';
        this.State.browserLanguage = 'en';
      } else {
        Cookie.set('userLanguage', 'zh', {
          domain: '.tvunetworks.com'
        });
        this.$i18n.locale = 'zh';
        this.State.browserLanguage = 'zh';
      }
    },
    closeMic() {
      this.startOrStop = false;
    },
    // 处理关闭弹窗打开音量柱
    async closedMic() {
      this.localAudioTrack && (await this.localAudioTrack.setEnabled(true));
      if (this.localAudioTrack) {
        const media = new MediaStream();
        media.addTrack(this.localAudioTrack._mediaStreamTrack);
        audioContextObj.audioTrack(media, 'volume');
        setTimeout(() => {
          audioContextObj.resumeAudio('volume');
        }, 1000);
      }
    },
    async startTesting() {
      this.startOrStop = !this.startOrStop;
      if (this.startOrStop == true && this.localAudioTrack) {
        await this.localAudioTrack.setEnabled(true);
        const media = new MediaStream();
        media.addTrack(this.localAudioTrack._mediaStreamTrack);
        audioContextObj.audioTrack(media, 'volume');
        setTimeout(() => {
          audioContextObj.resumeAudio('volume');
        }, 1000);
      }
    },
    async handleAudio(val) {
      this.startOrStop = false;
      this.id = val;
      // 同步视频流上mic设备
      this.devicesInfo.microphoneId = val;
      // 初始化麦克风声音
      if (this.rtc && this.rtc._AgoraRTC && !this.devicesInfo.microphoneError) {
        this.localAudioTrack = await this.rtc._AgoraRTC.createMicrophoneAudioTrack({
          AEC: true,
          // 回声消除
          ANS: true,
          // 噪声抑制
          microphoneId: val // 指定麦克风
        });
      }

      this.localAudioTrack && (await this.localAudioTrack.setDevice(val));
    },
    openTestMic() {
      this.testMicVisible = true;
      // 不显示音量柱
      if (this.localAudioTrack) {
        this.localAudioTrack.setEnabled(false);
        this.localAudioTrack.stop();
      }
    },
    async checkIsHost() {
      if (!this.partyCode) return;
      let haveHistoryMem = '';
      if (this.partyCode.length == 16) {
        haveHistoryMem = handleLocalStorage('get', 'galleryMemberId') || 'PL_' + new Date().getTime();
      } else {
        haveHistoryMem = handleLocalStorage('get', 'memberId') || this.State.loginInfo.id || 'PL_' + new Date().getTime();
      }
      const params = {
        partyCode: this.partyCode,
        clientType: 0,
        memberId: haveHistoryMem
      };
      if (this.partyCode.length > 20) {
        this.$message.error(this.$t('common.invalidPartyIdText'));
        return;
      }
      await this.axios.get('/partyline-backend/party/noLogin/checkV2', {
        params
      }, {
        errorTip: false
      }).then(res => {
        if (!res) return;
        if (res.data && res.data.errorCode === '0x0') {
          const result = res.data.result;
          this.checkInfo = result;
          if (!result.enable) this.$router.push({
            name: 'remove',
            query: {
              type: 'disableParty'
            }
          });
          // 判断是否是commentator的party
          if (result.channelModel == 12 && this.State.config.urlInfo.commentatorParty.includes('/commentator') && this.partyCode) {
            window.location.href = `${this.State.config.urlInfo.commentatorParty}?join_id=${this.partyCode}`;
            return;
          }
          if (!result.commonPartyInfo) return;
          this.commonPartyInfo = result.commonPartyInfo;
          this.nickName = this.commonPartyInfo.nickname;
          if (this.checkInfo.owner && !this.nickName) {
            this.splitEmail = result.userEmail.split('@')[0];
          } else if (this.nickName) {
            this.splitEmail = this.nickName;
          }
          if (this.commonPartyInfo.partyName) {
            this.partyName = this.commonPartyInfo.partyName;
          } else {
            this.partyName = new Date(this.commonPartyInfo.startPartyTime || this.commonPartyInfo.createTime).toLocaleDateString() + '   ' + new Date(this.commonPartyInfo.startPartyTime || this.commonPartyInfo.createTime).toLocaleTimeString();
          }
          addTabTitle({
            userInfo: result.commonPartyInfo,
            useTime: true
          });
          this.oldPartyName = JSON.parse(JSON.stringify(this.partyName));
        }
      }).catch(e => {
        console.log('check interface failed');
      });
    },
    getMediaDeviceStatus() {
      if (!this.partyCode && !this.State.partyCode) return;
      const params = {
        originRtilCode: this.userInfo.rtilCode,
        annotation: this.partyCode || this.State.partyCode,
        keys: ['nickName', 'tagName', 'talkBack', 'camera', 'mic', 'blockAudio', 'blockVideo', 'voipRid', 'voipSourceId', 'flipVideo'],
        marks: [id]
      };
      this.axios.get('/partyline-backend/behavior/noLogin/getList', {
        params
      }, {
        errorTip: false
      }).then(res => {
        if (res.data.errorCode === '0x0') {}
      });
    },
    async setCameraOrMic(type) {
      if (type === 'muteVideo') {
        if (!this.camera && (this.checkInfo.channelModel == 1 || this.checkInfo.channelModel == 13) && this.checkInfo.owner) {
          return;
        }
        const canExecute = judgeCanControl('video', this.devicesInfo);
        if (!canExecute) return;
        this.camera = !this.camera;
        if (this.localVideoTrack) {
          this.camera ? this.localVideoTrack.play('local_stream', {
            mirror: true
          }) : this.localVideoTrack.stop();
          this.localVideoTrack.setEnabled(this.camera);
        }
      } else {
        const canExecute = judgeCanControl('audio', this.devicesInfo);
        if (!canExecute) return;
        this.mic = !this.mic;
        if (!this.mic && this.speaker && this.localAudioTrack) {
          this.localAudioTrack.setEnabled(false);
        } else if (this.mic && this.speaker && this.localAudioTrack) {
          await this.localAudioTrack.setEnabled(true);
          const media = new MediaStream();
          media.addTrack(this.localAudioTrack._mediaStreamTrack);
          audioContextObj.audioTrack(media, 'volume');
          setTimeout(() => {
            audioContextObj.resumeAudio('volume');
          }, 1000);
        }
      }
    },
    async changeDevice(val) {
      if ((this.checkInfo.channelModel == 1 || this.checkInfo.channelModel == 13) && this.checkInfo.owner) {
        return;
      }
      if (!this.rtc) return;
      const params = {
        type: val.type,
        deviceId: val.deviceId,
        track: val.type === 'audio' ? this.localAudioTrack : val.type === 'video' ? this.localVideoTrack : '',
        devicesInfo: this.devicesInfo
      };
      if (val.type === 'video') {
        this.showInitMessage = true;
        this.State.initCamera = true;
        this.State.showInitCameraTips = false;
        if (this.localVideoTrack) {
          const lastDeviceId = this.localVideoTrack._config.cameraId;
          changeDeviceAndSaveId(params, result => {
            const {
              type
            } = result;
            if (type !== 'success') {
              this.$refs.cameraDevice.changeDeviceId(lastDeviceId);
              this.$message.warning({
                message: this.$t('common.switchFailed'),
                type: 'warning',
                offset: 50,
                showClose: true
              });
            }
            this.showInitMessage = false;
            this.State.initCamera = false;
          });
        } else {
          this.localVideoTrack = await createCameraVideoTrack({
            cameraId: val.deviceId,
            config: {},
            AgoraRTC: this.rtc._AgoraRTC
          });
          if (this.localVideoTrack) {
            playVideoTrack(this.localVideoTrack);
            const key = val.type === 'audio' ? 'microphoneId' : 'cameraId';
            handleLocalStorage('set', key, params.deviceId);
          } else {
            this.devicesInfo && this.devicesInfo.cameraList.forEach(item => {
              if (item.deviceId == val.deviceId) {
                this.cameraName = item.label;
                this.State.showInitCameraTips = true;
              }
            });
          }
          this.showInitMessage = false;
          this.State.initCamera = false;
        }
      } else {
        if (this.localAudioTrack) {
          changeDeviceAndSaveId(params, result => {
            const {
              type
            } = result;
            if (type === 'success') {
              const media = new MediaStream();
              media.addTrack(this.localAudioTrack._mediaStreamTrack);
              audioContextObj.audioTrack(media, 'volume');
              setTimeout(() => {
                audioContextObj.resumeAudio('volume');
              }, 1000);
            }
          });
        } else {
          if (this.devicesInfo.microphoneError) return;
          this.localAudioTrack = await createMicrophoneAudioTrack({
            rtc: this.rtc,
            config: {
              AEC: true,
              // 回声消除
              ANS: true,
              // 噪声抑制
              microphoneId: val.deviceId
            }
          });
        }
      }
    },
    changeMute() {
      this.speaker = !this.speaker;
    },
    async agoraCallback({
      action,
      payload
    }) {
      var _this$localAudioTrack, _this$localAudioTrack2;
      const {
        changeDevice
      } = payload;
      switch (action) {
        case 'cameraChange':
          if (!this.rtc) return;
          this.devicesInfo = await this.rtc.getDevice();
          if (this.localVideoTrack && changeDevice.device.label === this.localVideoTrack.getTrackLabel()) {
            const oldCameras = await this.rtc._AgoraRTC.getCameras();
            oldCameras[0] && this.rtc.setDevice(oldCameras[0].deviceId, 'video', returnType => {
              this.devicesInfo.cameraId = oldCameras[0].deviceId;
              returnType === 'success' ? this.$message.success(this.$t('common.autoSwitchNewCameraSuccess')) : this.$message.error(this.$t('common.autoSwitchNewCameraFailed'));
            }, this.localVideoTrack);
          }
          break;
        case 'micChange':
          if (!this.rtc) return;
          this.startOrStop = false;
          this.devicesInfo = await this.rtc.getDevice();
          if (this.localAudioTrack && ((_this$localAudioTrack = this.localAudioTrack._deviceName) !== null && _this$localAudioTrack !== void 0 && _this$localAudioTrack.includes(changeDevice.device.label) || changeDevice.state === 'INACTIVE' && this.localAudioTrack._config.microphoneId == 'default')) {
            const oldMic = await this.rtc._AgoraRTC.getMicrophones();
            oldMic[0] && this.rtc.setDevice(oldMic[0].deviceId, 'audio', returnType => {
              returnType === 'success' ? this.$message.success(this.$t('common.autoSwitchNewMicSuccess')) : this.$message.error(this.$t('common.autoSwitchNewMicFailed'));
              this.devicesInfo.microphoneId = oldMic[0].deviceId;
              this.deviceId = oldMic[0].deviceId;
              this.startOrStop = false;
            }, this.localAudioTrack);
          } else if (changeDevice.state === 'ACTIVE' && this.localAudioTrack && !((_this$localAudioTrack2 = this.localAudioTrack._deviceName) !== null && _this$localAudioTrack2 !== void 0 && _this$localAudioTrack2.includes(changeDevice.device.label)) && this.localAudioTrack._config.microphoneId != 'default') {
            var _this$devicesInfo;
            // 插入mic
            if (this.mic) {
              this.localAudioTrack && this.localAudioTrack.setEnabled(false);
              this.localAudioTrack && this.localAudioTrack.setEnabled(true);
            }
            if (((_this$devicesInfo = this.devicesInfo) === null || _this$devicesInfo === void 0 ? void 0 : _this$devicesInfo.microphoneList[0].label) != this.localAudioTrack._deviceName) {
              this.$message.success(this.$t('common.autoSwitchNewMicSuccess'));
            }
          }
          break;
      }
    },
    async jumpPage() {
      if (!this.judgeCanJump()) {
        return;
      }
      const saveSuceess = await this.saveNickName();
      if (!saveSuceess) {
        return;
      }
      if (this.partyName && this.partyName != this.oldPartyName) {
        await this.updateTitle();
      }
      const publicPath = this.State.publicPath || 'partyline';
      if (this.checkInfo.channelModel == 18) {
        if (this.State.hasLogin) {
          window.location.href = `${location.origin}/${publicPath}/participate/${this.State.participateChannelMode[this.checkInfo.channelModel]}?model=station&id=${this.partyCode}`;
        } else {
          this.$router.push({
            name: 'joinOrStart',
            query: {
              model: 'station',
              partyCode: this.partyCode
            }
          });
        }
      } else {
        if (this.checkInfo.owner) {
          window.location.href = `${location.origin}/${publicPath}/control/${this.State.channelModeByRouteName[this.checkInfo.channelModel]}?id=${this.partyCode}`;
        } else {
          window.location.href = `${location.origin}/${publicPath}/participate/${this.State.participateChannelMode[this.checkInfo.channelModel]}?id=${this.partyCode}`;
        }
      }
    },
    judgeCanJump() {
      let flag = true;
      if (!this.partyCode) {
        this.$message.error(this.$t('partyInfo.noPartyCode'));
        flag = false;
      }
      if (this.checkInfo.owner) {
        if (!this.partyName || (this.checkInfo.channelModel == 0 || this.checkInfo.channelModel == 2) && !this.splitEmail) {
          this.$message.error(this.$t('partyInfo.joinFailed'));
          flag = false;
        }
      } else {
        if (!this.splitEmail && this.checkInfo.channelModel != 1) {
          this.$message.error(this.$t('partyInfo.nameCannotEmpty'));
          flag = false;
        }
      }
      if (!this.checkInfo.enable) {
        flag = false;
        this.$message.error(this.$t('partyInfo.partyDisabled'));
      }
      return flag;
    },
    async saveNickName() {
      this.splitEmail = this.splitEmail || ' ';
      let data = [];
      let flag = true;
      if (this.State.hasVideo && this.camera) {
        this.setInfo.camera = true;
      } else {
        this.setInfo.camera = false;
      }
      if (this.State.hasAudio && this.mic) {
        this.setInfo.mic = true;
      } else {
        this.setInfo.mic = false;
      }
      this.setInfo.speaker = this.speaker;
      this.setInfo.noHaveCamera = !this.State.hasVideo;
      this.setInfo.useCamera = this.State.hasVideo ? '1' : '3';
      data = [{
        mark: '',
        annotation: this.partyCode,
        key: 'nickName',
        value: this.splitEmail,
        notify: true,
        initiator: ''
      }, {
        mark: '',
        annotation: this.partyCode,
        key: 'speaker',
        value: this.setInfo.speaker,
        notify: true,
        initiator: ''
      }, {
        mark: '',
        annotation: this.partyCode,
        key: 'camera',
        value: this.setInfo.camera,
        notify: true,
        initiator: ''
      }, {
        mark: '',
        annotation: this.partyCode,
        key: 'useCamera',
        value: this.setInfo.useCamera,
        notify: true,
        initiator: ''
      }, {
        mark: '',
        annotation: this.partyCode,
        key: 'mic',
        value: this.setInfo.mic,
        notify: true,
        initiator: ''
      }, {
        mark: '',
        annotation: this.partyCode,
        key: 'noHaveCamera',
        value: this.setInfo.noHaveCamera,
        notify: true,
        initiator: ''
      }];
      if (this.State.participateChannelMode[this.checkInfo.channelModel] == 'reporter' || this.State.channelModeByRouteName[this.checkInfo.channelModel] == 'coordinator') {
        data.push({
          mark: '',
          annotation: this.partyCode,
          key: 'organization',
          value: this.organization,
          notify: true,
          initiator: ''
        });
      }
      let haveHistoryMem = '';
      // Gallery view 模式特殊
      if (this.checkInfo.channelModel == 1) {
        const id = this.State.loginInfo.id ? this.State.loginInfo.id + '_' + Date.now() : '';
        haveHistoryMem = handleLocalStorage('get', 'galleryMemberId') || id;
      } else {
        haveHistoryMem = this.State.loginInfo.id || handleLocalStorage('get', 'memberId');
      }
      const params = {
        memberId: haveHistoryMem || 'PL_' + new Date().getTime(),
        partyCode: this.partyCode,
        role: 0,
        type: 3,
        host: this.checkInfo.owner,
        behaviorKeyList: ['hearSelf', 'speaker', 'nickName', 'mic', 'camera', 'audioOnlyType', 'checkAudioMainWindow', 'checkAudioShare', 'enableControlMedia', 'flipVideo'],
        behaviors: data,
        invitePassCode: this.passCode
      };
      await this.axios.post('/partyline-backend/party/noLogin/join', params).then(async res => {
        if (!res) return;
        if (res.data.errorCode != '0x0') {
          flag = false;
        }
        this.checkInfo.channelModel == 1 ? handleLocalStorage('set', 'galleryMemberId', params.memberId) : handleLocalStorage('set', 'memberId', params.memberId);
      });
      return flag;
    },
    async updateTitle() {
      const params = {
        id: this.checkInfo.commonPartyInfo.id,
        title: this.partyName
      };
      await this.axios.post(this.updateTitleUrl[this.checkInfo.channelModel], params).then(res => {});
    }
  },
  async beforeRouteLeave(to, from, next) {
    this.localVideoTrack && (await this.localVideoTrack.setEnabled(false));
    this.localAudioTrack && (await this.localAudioTrack.setEnabled(false));
    setTimeout(() => {
      next();
    }, 1000);
  }
};